.container {
  position: relative;
  width: 100%;
  height: 12.8rem;
  overflow: hidden;
  cursor: pointer;
  border-radius: 0.6rem;
  box-sizing: border-box;
  border: 1px solid transparent;

  &[data-selected='true'] {
    border: 1px solid var(--color-primary-crayola, #367bff);
  }

  /* @media screen and (min-width: $bp-medium) {
    min-width: 12.8rem;
  } */
}

.cover {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(180deg, rgba(37, 39, 45, 0.25) 0%, #181a1e 73.5%),
    var(--template-cover);
  background-blend-mode: multiply;
  background-position: center;
  background-size: cover;
  transition: transform 0.3s ease-in-out;

  &[data-disabled] {
    background: linear-gradient(#141619cc, #141619cc), var(--template-cover);
    background-size: cover;
  }
}

.badge {
  position: absolute;
  top: 0.8rem;
  left: 0.8rem;
  background: #25272d;
  color: var(--color-grayscale-white);
  font-size: 1.2rem;
  font-weight: 400;
  padding: 0.4rem;
  border-radius: 0.4rem;
}

.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 1.6rem;
  z-index: 1;
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
}

.title {
  font-weight: 600;
}

.subtitle {
  color: var(--color-grayscale-manatee);
  font-size: 1.4rem;
  font-weight: 400;
}

.footer {
  position: relative;
  z-index: 5;

  & > button {
    background: rgba(20, 22, 25, 0.7);

    svg {
      stroke: var(--text-color-white);
      color: white;
    }
  }
}
